import styled from '@emotion/styled'

import { BRAND_COLOR, SUB_COLOR } from '@/constants/colors'

const WEAK_BG_COLOR = '#e4e5e7'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1;
  align-self: stretch;
  padding: 20px 20px calc(20px + var(--safe-bottom, 0px));
  position: relative;
  overflow: hidden;
`

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

export const BottomArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: auto;
  width: 100%;
`

export const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
`

export const PriceText = styled.p`
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: -0.42px;
  color: ${BRAND_COLOR};
`

export const DescriptionText = styled.p`
  font-size: 26px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -0.39px;
  color: #1b1c1d;
  text-align: center;
  white-space: pre-line;
`

export const FooterText = styled.p`
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.075px;
  color: ${SUB_COLOR};
  text-align: center;
`

export const ButtonArea = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  padding: 12px;
`

export const CloseButton = styled.button`
  flex-shrink: 0;
  height: 56px;
  padding: 12px 40px;
  background-color: ${WEAK_BG_COLOR};
  border: none;
  border-radius: 16px;
  font-size: 17px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.17px;
  color: #3f4145;
  cursor: pointer;
  white-space: nowrap;
`

export const ActionButton = styled.button`
  flex: 1;
  height: 56px;
  padding: 12px;
  background-color: ${BRAND_COLOR};
  border: none;
  border-radius: 16px;
  font-size: 17px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.17px;
  color: white;
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
`

const PROGRESS_COLOR = '#22c55e'

export const MinorPriceText = styled.p`
  font-size: 26px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -0.39px;
  color: #1b1c1d;
`

export const MinorDescriptionText = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: #1b1c1d;
`

export const ProgressCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding: 20px 24px 16px;
  background-color: #f5f5f6;
  border-radius: 16px;
  overflow: hidden;
  margin-top: 40px;
`

export const ProgressHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const CloverIcon = styled.img`
  width: 36px;
  height: 44px;
  flex-shrink: 0;
`

export const ProgressTextArea = styled.div`
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: -0.075px;
  color: #1b1c1d;
  white-space: nowrap;
`

export const ProgressGreenText = styled.span`
  color: ${PROGRESS_COLOR};
`

export const ProgressBarArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`

export const ProgressBarTrack = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${WEAK_BG_COLOR};
  border-radius: 8px;
  overflow: hidden;
`

export const ProgressBarFill = styled.div<{ percent: number }>`
  width: ${({ percent }) => percent}%;
  height: 100%;
  background-color: ${PROGRESS_COLOR};
  border-radius: 8px;
`

export const ProgressLabels = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.06px;
`

export const ProgressLabelCurrent = styled.span`
  color: ${PROGRESS_COLOR};
`

export const ProgressLabelEnd = styled.span`
  color: ${SUB_COLOR};
`

export const LottieWrapper = styled.div`
  width: 240px;
  height: 240px;
  margin-bottom: -60px;

  > div,
  > svg {
    width: 100% !important;
    height: 100% !important;
  }
`
